import mysql from "./mysql.png";
import postgresql from "./postgresql.svg";
import { tKey } from "ember-intl";

export default {
  all: (intl) => [
    {
      label: "MySQL",
      icon: mysql,
      description: intl.t(tKey("databases.create.engines.mysql.description")),
      versions: [{ id: "8.4", value: "8.4" }],
      selected: { id: "8.4", value: "8.4" },
    },
    {
      label: "PostgreSQL",
      icon: postgresql,
      description: intl.t(tKey("databases.create.engines.postgresql.description")),
      versions: [{ id: "18", value: "18" }],
      selected: { id: "18", value: "18" },
    },
  ],
};
